// extracted by mini-css-extract-plugin
export var container = "Team-module--container--60def";
export var layout = "Team-module--layout--e9b29";
export var sliderWrapper = "Team-module--sliderWrapper--61a66";
export var slide = "Team-module--slide--94d54";